import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

import { ReactComponent as DialogAlert } from "../../../assets/images/dialog-alert.svg";
import CloseIcon from "../../../assets/images/plus-circle-fill.svg";

const SimpleDialog = (props) => {
  const { t } = useTranslation();
  const handleClose = () => {
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <DialogAlert></DialogAlert>
            <Typography color={"#CC6058"} variant="h3" mt={3}>{props.title}</Typography>
            <pre><Typography textAlign="center" mt={2}>{props.text}</Typography></pre>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={e=> props.tryAgain(true)} size="large" variant="contained" sx={{ width: '300px', textTransform: "none" }} color={"red"}>{t(`label.TryAgain`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default SimpleDialog;
